// Style
// Page Base
import 'hellospa/dig';

import React from 'react';
import ReactDOM from 'react-dom';
import {
  BundleProps,
  parseBundleProps,
} from 'common/utils/parse-dom-node-contents';
import configureRaven from 'common/utils/sentry';
import { initializeDebugTraceKey } from 'js/sign-components/common/debug-trace-key';
import { initializePAPConsentHandling } from 'js/sign-components/common/product-analytics-pipeline';
import 'hello-react/common/global-styles.css';
import HelloReactApplication from 'hello-react/components/hello-react-application';
import { hasFeatureFlagFactory } from 'js/sign-components/common/check-feature-flag';
import { buildWebAppClient } from 'hello-react/web-app-client/build-web-app-client';
import { constructStore } from 'hellospa/redux/store';
import { loggedOutRoutes } from './routes';
import ErrorBoundary from 'signer-app/parts/error-boundary';

initializePAPConsentHandling();

function Root({ csrfToken, featureFlags }: BundleProps) {
  const appActions = buildWebAppClient('');
  const store = constructStore(() => ({
    appActions,
    featureFlags,
    hasFeatureFlag: hasFeatureFlagFactory(featureFlags),
  }));
  return (
    <HelloReactApplication
      appActions={appActions}
      featureFlags={featureFlags}
      store={store}
      csrfToken={csrfToken}
    >
      <ErrorBoundary>{loggedOutRoutes}</ErrorBoundary>
    </HelloReactApplication>
  );
}

function run() {
  const bundleProps = parseBundleProps();
  const featureFlags = bundleProps?.featureFlags;

  // Initialize debug trace key before Sentry configuration
  initializeDebugTraceKey();

  configureRaven(
    {
      id: bundleProps.userGuid,
    },
    featureFlags,
  );

  ReactDOM.render(<Root {...bundleProps} />, document.getElementById('root'));
}

run();
